/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */
// Copyright 2021 channysok

import React, { useEffect, useState, useCallback } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBackspace, faBarcode, faBox, faCalendar, faCheck, faCheckCircle, faCloudUploadAlt, faCode, faCross, faDollarSign, faEdit, faHome, faHSquare, faPeopleArrows, faPhone, faPlug, faQrcode, faRocket, faSave, faSearch, faTasks, faUser, faUserShield, faWarehouse } from "@fortawesome/free-solid-svg-icons"
import { Badge, Button, ButtonGroup, Card, Col, Dropdown, Form, FormGroup, Image, InputGroup, Pagination, ProgressBar, Row, Table } from '@themesberg/react-bootstrap'
import Datetime from "react-datetime";
import { useDispatch, useSelector } from "react-redux"
import WaybillAction from "../../core/redux/action/WaybillAction"
import _ from "lodash"
import { WaybillStatus, WaybillStatusType } from "../waybills/WaybillPage"

import Progress from "../../components/Progress"
import { GetResultObject, PostRequest } from '../../core/API'
import { ApiSrc } from '../../resources/ApiSrc'
import { faServicestack } from "@fortawesome/free-brands-svg-icons";
import BundleAction from "../../core/redux/action/BundleAction";

var Barcode = require('react-barcode');

const moment = require('moment');

export default (props) => {

    const [waybill, setWaybill] = useState()

    const [paidAmount, setPaidAmount] = useState()
    const [paidAt, setPaidAt] = useState()
    const [reference, setReference] = useState()
    const [serviceType, setServiceType] = useState('pickup')
    const [paymentType, setPaymentType] = useState('wallet')
    
    const [receiver, setReceiver] = useState()
    const [waybills, setWaybills] = useState([])

    const [errorMessage, setErrorMessage] = useState()
    const [progressValue, setProgressValue] = useState()
    const [totalFee, setTotalFee] = useState()
    //const [deliveryFee, setDeliveryFee] = useState(0)
    const [joonaakFee, setJoonaakFee] = useState(0)
    const [setting, setSetting] = useState()

    const dispatch = useDispatch();

    useEffect(()=>{
        PostRequest(ApiSrc.GET_SETTING, {input: {

        }}).then(result => {
            GetResultObject(result, 'data', 200, (data) => {
                var sts = _.groupBy(data, 'key')
                setSetting(sts)
            })
        })
    }, [])

    useEffect(()=>{
        setPaidAmount(totalFee)
    }, [totalFee])
        
    const doneTyping = () => {                        
        if(reference == '' || reference == undefined) return
        setErrorMessage(undefined)
        PostRequest(ApiSrc.LIST_WAYBILL, { input: { reference} }).then(result => {
            GetResultObject(result, 'data.content', 200, (data) => {                
                if(data.length > 0) {
                    const item = data[0]
                    if(_.get(item, 'paid')) {
                        setErrorMessage(`Thew item already PAID. Reference ${reference}`)
                    } else if(_.get(item, 'status') == WaybillStatusType.ARRIVED) {
                        if(receiver == undefined) {
                            setReceiver(_.get(item, 'receiver'))
                            setWaybills([item,...waybills])
                            setTotalFee(_.get(item, 'freightFee') ? _.get(item, 'freightFee') : 0)
                        } else if(_.get(receiver, 'id') == _.get(item, 'receiver.id')){
                            
                            var wbs = waybills.filter(wb=> {
                                if(_.get(wb, 'id') == _.get(item, 'id')) return wb
                            })

                            if(setting['allow_mix_arrived_date_bundle'] != 'yes') {
                                if(moment(_.get(item, 'arrivedAt')).format('MMM DD,yyyy') != moment(_.get(waybills, '[0].arrivedAt')).format('MMM DD,yyyy')) {
                                    setErrorMessage(`The item not arrived in the same date. Reference ${reference}`)
                                    return
                                }
                            }

                            if(wbs.length > 0) {
                                setErrorMessage(`Already scan into the bundle sheet. Reference ${reference}`)
                                return
                            } 
                            setWaybills([item,...waybills])
                            setTotalFee(totalFee + (_.get(item, 'freightFee') ? _.get(item, 'freightFee') : 0))                            
                        } else {
                            setErrorMessage(`The receiver account is not match. Reference ${reference}`)
                        }
                    } else {
                        setErrorMessage(`Incorrect Status, Arrived status is allow. Reference ${reference}`)    
                    }
                } else {
                    setErrorMessage(`Item not found. Reference ${reference}`)
                }
                //     setWaybill(data[0])
                setReference('')
            })
        })        
    }

    useEffect(() => {
        doneTyping()
    }, [reference])


    const escFunction = useCallback((event) => {
        if (event.keyCode === 27) {
            //Do whatever when esc is pressed
            props.onClose && props.onClose()
        }
        //  else  if (event.keyCode === 13) {
        //     doneTyping()
        // }
    }, [props]);

    useEffect(() => {
        document.addEventListener("keydown", escFunction, false);

        return () => {
            document.removeEventListener("keydown", escFunction, false);
        };
    }, [escFunction]);



    const onSave = () => {
        const waybillIds = waybills.map(item=> {return _.get(item, 'id')})
        const body = {
            waybillIds,
            receiverId: _.get(receiver, 'id'),
            totalFee: parseFloat(totalFee) + parseFloat(joonaakFee),
            joonaakFee,
            deliveryFee: totalFee,
            paidAmount,
            paidAt,
            serviceType,
            paymentType            
        }

        if (paidAmount && paidAt) {
            body.paid = true
        }
        console.log('>> body', body)
        setProgressValue(30)
        PostRequest(ApiSrc.CREATE_BUNDLE, { input: { ...body }, token: null }).then(result =>
            GetResultObject(result, 'data', 200, (data) => {
                setProgressValue(100)
                dispatch(BundleAction.createBundleSuccess(data));
                let timer = setInterval(function () {
                    props.onClose && props.onClose(timer)
                }, 1000);
            })
        )        
    }



    

    return (
        <>
            {
                progressValue !== undefined && (<Progress variant="success" label="Progress..." value={progressValue ?? 1} />)
            }
            <Card>


                <Card.Body>
                    <Row>
                        
                        <Col xs={12} sm={6} xl={4}>                        
                            <Row>
                                <Form.Group className="mb-4">
                                    <Form.Label>Reference</Form.Label>
                                    <InputGroup>
                                        <InputGroup.Text className={'bg-warning'}>
                                            <FontAwesomeIcon icon={faBarcode} />
                                        </InputGroup.Text>
                                        <Form.Control       
                                            autoFocus={true}                                                                                                                       
                                            onChange={(e) => { 
                                                setReference(e.target.value) 
                                            }}
                                            value={reference}
                                        />
                                    </InputGroup>
                                    <Form.Label>{errorMessage}</Form.Label>
                                </Form.Group>                                    

                                <Form.Group className="mb-4">
                                    <Form.Label>Service Type</Form.Label>
                                    <InputGroup>
                                        <InputGroup.Text>
                                            <FontAwesomeIcon icon={faServicestack} />
                                        </InputGroup.Text>
                                        <Form.Select onChange={(e) => {                                                
                                            setServiceType(e.target.value)
                                        }}>
                                        <option value={'pickup'}>Self Pickup</option>
                                        <option value={'express'}>Express</option>
                                        <option value={'joonaak'}>Jonnak Delivery</option>                                        
                                        </Form.Select>                
                                    </InputGroup>
                                </Form.Group> 

                                <Form.Group className="mb-4">
                                    <Form.Label>Payment Type</Form.Label>
                                    <InputGroup>
                                        <InputGroup.Text>
                                            <FontAwesomeIcon icon={faDollarSign} />
                                        </InputGroup.Text>
                                        <Form.Select onChange={(e) => {                                                
                                            setPaymentType(e.target.value)
                                        }}>                                        
                                        <option value={'wallet'}>Joonaak Wallet</option>
                                        <option value={'transfer'}>Transfer</option>
                                        <option value={'cash'}>Cash</option>
                                        </Form.Select>                
                                    </InputGroup>
                                </Form.Group> 

                                <Form.Group className="mb-4">
                                    <Form.Label>Settle Date</Form.Label>
                                    <InputGroup>                                        
                                        <Datetime
                                            timeFormat={false}
                                            onChange={setPaidAt}
                                            renderInput={(props, openCalendar) => (
                                                <InputGroup>
                                                    <InputGroup.Text><FontAwesomeIcon icon={faCalendar} /></InputGroup.Text>
                                                    <Form.Control
                                                        required
                                                        type="text"
                                                        value={paidAt ? moment(paidAt).format("MM-DD-YYYY") : ''}
                                                        placeholder="MM-DD-YYYY"
                                                        onFocus={openCalendar} />
                                                </InputGroup>
                                            )} />
                                    </InputGroup>
                                </Form.Group>                                                                                   

                                <InputGroup>
                                    <Row>                                        
                                        <Col>
                                            { reference && <Barcode value={reference} /> }
                                        </Col>
                                    </Row>
                                    
                                </InputGroup>

                                {
                                    _.get(waybill, 'photo') && (
                                        <Form.Group className="mb-4">
                                            <img src={_.get(waybill, 'photo')} />
                                        </Form.Group>
                                    )
                                }

                            </Row>
                        </Col>         
                        <Col xs={12} sm={12} xl={8}>                        
                            <Table responsive className="table-centered table-nowrap rounded mb-0">
                                <thead className="thead-light">
                                    <tr>
                                        <th width={'15%'} className="border-0">#</th>
                                        <th width={'45%'} className="border-0">Reference#</th>                                                                 
                                        <th width={'20%'} className="border-0">freight Fee($)</th>  
                                        <th width={'20%'} className="border-0">Arrived Date</th>                                                                                                                                                                                 
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        waybills && waybills.map((item, index) => {
                                            return (
                                                <tr>
                                                    <td>
                                                        {waybills.length-index}
                                                        
                                                    </td>
                                                    <td>
                                                        {_.get(item, 'reference')}
                                                        <br></br>
                                                        <small style={{ fontSize: '8pt', color: 'green' }}>{_.get(item, 'receiver.accountNo')}</small>
                                                        <br></br>
                                                        <small style={{ fontSize: '8pt', color: 'green' }}>+{_.get(item, 'receiver.countryCode')} {_.get(item, 'receiver.phone')}</small>                                                    
                                                    </td>
                                                    <td>
                                                        {_.get(item, 'freightFee', '0')}
                                                    </td>
                                                    <td>
                                                        {
                                                            moment(_.get(item, 'arrivedAt')).format('MMM DD,yyyy')
                                                        }
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                    
                                </tbody>                                
                                
                                <tfoot>
                                    <tr>
                                        <td>                                        
                                            <span className={'text-muted'}>Freight Fee</span>
                                        </td>
                                        <td>                                        
                                        </td>
                                        <td colSpan={2}>
                                            <input disabled type='number' step='0.001' className={'form-control'} value={totalFee}/>
                                        </td>                                    
                                    </tr>
                                    <tr>
                                        <td>                                        
                                            <span className={'text-muted'}>Delivery Fee</span>
                                        </td>
                                        <td>                                        
                                        </td>
                                        <td colSpan={2}>
                                            <input onChange={(e) => setJoonaakFee(e.target.value)} min={0} type='number' step='0.001' className={'form-control'} value={joonaakFee}/>
                                        </td>                                    
                                    </tr>
                                    <tr>
                                        <td>                                        
                                            <span className={'text-muted'}>Paid Amount</span>
                                        </td>
                                        <td>                                        
                                        </td>
                                        <td colSpan={2}>
                                            <input disabled type='number' step='0.001' className={'form-control'} value={parseFloat(totalFee) + parseFloat(joonaakFee)}/>
                                        </td>                                    
                                    </tr>
                                </tfoot>
                            </Table>
                            <br></br>
                            <Form.Group className="mb-4 float-end">
                            <Button
                                className={'bg-danger'}
                                onClick={()=> {
                                    props.onClose && props.onClose()
                                }}><FontAwesomeIcon icon={faBackspace} /> Cancel</Button> &nbsp;&nbsp;
                            <Button onClick={onSave}><FontAwesomeIcon icon={faSave} /> Save</Button>
                            </Form.Group>
                        </Col>               
                    </Row>

                </Card.Body>                                
            </Card>
        </>
    )
}
